/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 2H12.5V2C14.8297 2 15.9946 2 16.9134 2.3806C18.1386 2.88807 19.1119 3.86144 19.6194 5.08658C20 6.00544 20 7.17029 20 9.5V13.5V14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 2H11.5V2C9.17029 2 8.00544 2 7.08658 2.3806C5.86144 2.88807 4.88807 3.86144 4.3806 5.08658C4 6.00544 4 7.17029 4 9.5V22L6.27567 20.8622C8.37458 19.8127 9.42404 19.288 10.5248 19.0815C11.4998 18.8985 12.5002 18.8985 13.4752 19.0815C14.576 19.288 15.6254 19.8127 17.7243 20.8622L20 22V15V14.125"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M20 22V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V22L6.27567 20.8622L6.27569 20.8622C8.37459 19.8127 9.42404 19.288 10.5248 19.0815C11.4998 18.8985 12.5002 18.8985 13.4752 19.0815C14.576 19.288 15.6254 19.8127 17.7243 20.8622L17.7243 20.8622L20 22Z"
				fill="currentColor"
			/>
			<path
				d="M20 22V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V22L6.27567 20.8622L6.27569 20.8622C8.37459 19.8127 9.42404 19.288 10.5248 19.0815C11.4998 18.8985 12.5002 18.8985 13.4752 19.0815C14.576 19.288 15.6254 19.8127 17.7243 20.8622L17.7243 20.8622L20 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M11.25 1.25C8.44974 1.25 7.04961 1.25 5.98005 1.79497C5.03924 2.27433 4.27433 3.03924 3.79497 3.98005C3.25 5.04961 3.25 6.44974 3.25 9.25001V20.6247C3.25 21.4819 3.25 21.9105 3.43054 22.1686C3.58819 22.394 3.83173 22.5445 4.10384 22.5848C4.41546 22.6308 4.79882 22.4391 5.56554 22.0558L6.27566 21.7007C8.37458 20.6512 9.42404 20.1265 10.5248 19.92C11.4998 19.7371 12.5002 19.7371 13.4752 19.92C14.576 20.1265 15.6254 20.6512 17.7243 21.7007L18.4345 22.0558C19.2012 22.4391 19.5845 22.6308 19.8962 22.5848C20.1683 22.5445 20.4118 22.394 20.5695 22.1686C20.75 21.9105 20.75 21.4819 20.75 20.6247V9.25C20.75 6.44974 20.75 5.04961 20.205 3.98005C19.7257 3.03924 18.9608 2.27433 18.02 1.79497C16.9504 1.25 15.5503 1.25 12.75 1.25H11.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M20 13V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2V2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V22L6.27567 20.8622C8.37458 19.8127 9.42404 19.288 10.5248 19.0815C11.4998 18.8985 12.5002 18.8985 13.4752 19.0815C14.576 19.288 15.6254 19.8127 17.7243 20.8622L20 22V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M20 22V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V22L6.27567 20.8622L6.27569 20.8622C8.37459 19.8127 9.42404 19.288 10.5248 19.0815C11.4998 18.8985 12.5002 18.8985 13.4752 19.0815C14.576 19.288 15.6254 19.8127 17.7243 20.8622L17.7243 20.8622L20 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M11.25 1.25C8.44974 1.25 7.04961 1.25 5.98005 1.79497C5.03924 2.27433 4.27433 3.03924 3.79497 3.98005C3.25 5.04961 3.25 6.44974 3.25 9.25001V20.6247C3.25 21.4819 3.25 21.9105 3.43054 22.1686C3.58819 22.394 3.83173 22.5445 4.10384 22.5848C4.41546 22.6308 4.79882 22.4391 5.56554 22.0558L6.27566 21.7007C8.37458 20.6512 9.42404 20.1265 10.5248 19.92C11.4998 19.7371 12.5002 19.7371 13.4752 19.92C14.576 20.1265 15.6254 20.6512 17.7243 21.7007L18.4345 22.0558C19.2012 22.4391 19.5845 22.6308 19.8962 22.5848C20.1683 22.5445 20.4118 22.394 20.5695 22.1686C20.75 21.9105 20.75 21.4819 20.75 20.6247V9.25C20.75 6.44974 20.75 5.04961 20.205 3.98005C19.7257 3.03924 18.9608 2.27433 18.02 1.79497C16.9504 1.25 15.5503 1.25 12.75 1.25H11.25Z"
				fill="currentColor"
			/>
			<path
				d="M12.75 1.25H11.25C8.44974 1.25 7.04961 1.25 5.98005 1.79497C5.03924 2.27433 4.27433 3.03924 3.79497 3.98005C3.25 5.04961 3.25 6.44974 3.25 9.25V12H20.75V9.25C20.75 6.44974 20.75 5.04961 20.205 3.98005C19.7257 3.03924 18.9608 2.27433 18.02 1.79497C16.9504 1.25 15.5503 1.25 12.75 1.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
